import { inject, Injectable, signal } from "@angular/core";
import { HoleType, PlayerSlot, Payment } from "./booking.types";
import { Course } from "../courses/course.types";
import { Member } from "../members/members.types";
import { SlotAvailability } from "../tee-off-times/tee-off-times.types";
import { toSignal } from "@angular/core/rxjs-interop";
import { UserService } from "../users/user.service";

@Injectable({
  providedIn: 'root',
})
export class BookingStateService {  
  private _userService = inject(UserService);
  
  user = toSignal(this._userService.user$, { initialValue: null });
  slots = signal<PlayerSlot[]>([]);
  course = signal<Course>(null);
  holeType = signal<HoleType>(HoleType.EighteenHoles);
  userMembers = signal<Member[]>([]);
  golfCarts = signal<PlayerSlot[][]>([]);
  date = signal<string>(null);
  slotAvailability = signal<SlotAvailability>(null);

  selectedPlayerSlot = signal<PlayerSlot & { index: number }>(null);
  selectedGolfCart = signal<PlayerSlot[]>(null);

  isLoading = signal<boolean>(false);

  reset() {
    this.slots.set([]);
    this.course.set(null);
    this.holeType.set(HoleType.EighteenHoles);
    this.golfCarts.set(null);    
    this.userMembers.set([]);
    this.golfCarts.set([]);
    this.date.set(null);    
    this.slotAvailability.set(null);

    this.selectedPlayerSlot.set(null);
    this.selectedGolfCart.set(null);
  }
}